import { jsxs as _, jsx as r, Fragment as Fe } from "react/jsx-runtime";
import { c as T, I as ue, S as Me } from "./Section-DOeCOW54.js";
import S, { useState as N, useCallback as _e, useEffect as ce, useRef as De } from "react";
import { r as ke, f as se, n as He, a as $e, s as ze, v as ae, S as fe, R as Ae, C as We, l as Le, T as Ve } from "./SelectBox-DpKLsQTl.js";
import { I as ye, F as ge } from "./Tooltip-DLbZm45k.js";
import { T as O, B as ie } from "./useMediaQuery-BZAMobKw.js";
import { C as Se } from "./Checkbox-CrXiJ6FE.js";
const qe = "elo-desktop", G = {
  "wage-summary-box": "elo-wage-summary-box",
  desktop: qe,
  "wage-summary-box__item": "elo-wage-summary-box__item",
  "wage-summary-box__item--title": "elo-wage-summary-box__item--title",
  "wage-summary-box__item--value": "elo-wage-summary-box__item--value",
  "wage-summary-box__item--triple": "elo-wage-summary-box__item--triple",
  "wage-summary-box__icon": "elo-wage-summary-box__icon",
  "wage-summary-box__btn-wrapper": "elo-wage-summary-box__btn-wrapper",
  "wage-summary-box__btn": "elo-wage-summary-box__btn"
}, Pe = S.forwardRef(
  ({ summaryData: e, buttonData: t, isCompare: n = !1, isTriple: a = !1, ...u }, l) => /* @__PURE__ */ _("div", { ref: l, ...u, className: G["wage-summary-box"], children: [
    e.map((c, o) => /* @__PURE__ */ _(
      "div",
      {
        className: T(G["wage-summary-box__item"], {
          [G["wage-summary-box__item--triple"]]: a
        }),
        children: [
          o === 0 && /* @__PURE__ */ r(
            ue,
            {
              name: "Savings",
              width: "24px",
              height: "24px",
              className: G["wage-summary-box__icon"]
            }
          ),
          /* @__PURE__ */ r(
            O,
            {
              type: o === 0 ? "label" : "paragraph",
              size: o === 0 ? "large" : "small",
              extraClass: G["wage-summary-box__item--title"],
              children: c.title
            }
          ),
          /* @__PURE__ */ _(
            O,
            {
              type: o === 0 ? "label" : "paragraph",
              size: o === 0 ? "large" : "small",
              extraClass: G["wage-summary-box__item--value"],
              children: [
                c.value ? c.value : "--",
                " ",
                c.currency
              ]
            }
          )
        ]
      },
      o
    )),
    !n && /* @__PURE__ */ r("div", { className: G["wage-summary-box__btn-wrapper"], children: t.map(
      (c, o) => ke(c, o, G["wage-summary-box__btn"])
    ) })
  ] })
), Ge = "elo-desktop", z = {
  "wage-accordion": "elo-wage-accordion",
  "wage-accordion__content": "elo-wage-accordion__content",
  "wage-accordion__content--open": "elo-wage-accordion__content--open",
  "wage-accordion__header": "elo-wage-accordion__header",
  "wage-accordion__header--wrapper": "elo-wage-accordion__header--wrapper",
  "wage-accordion__header--title": "elo-wage-accordion__header--title",
  "wage-accordion__header--icon": "elo-wage-accordion__header--icon",
  "wage-accordion__header--value": "elo-wage-accordion__header--value",
  "wage-accordion__header--icon--open": "elo-wage-accordion__header--icon--open",
  "wage-accordion__item": "elo-wage-accordion__item",
  desktop: Ge,
  "wage-accordion__item--title": "elo-wage-accordion__item--title",
  "wage-accordion__item--value": "elo-wage-accordion__item--value"
}, Ee = S.forwardRef(
  ({ header: e, data: t, lang: n, defaultOpen: a = !1, ...u }, l) => {
    const [c, o] = N(a), i = (g) => {
      g.key === "Enter" && o(!c), g.key === "Escape" && o(!1);
    };
    return /* @__PURE__ */ _(
      "div",
      {
        ref: l,
        ...u,
        className: z["wage-accordion"],
        tabIndex: 0,
        onKeyDown: i,
        "aria-expanded": c,
        "aria-controls": "wage-accordion__content",
        children: [
          /* @__PURE__ */ _(
            "div",
            {
              className: z["wage-accordion__header"],
              onClick: () => o(!c),
              "aria-controls": "wage-accordion__content",
              children: [
                /* @__PURE__ */ _("div", { className: z["wage-accordion__header--wrapper"], lang: n, children: [
                  /* @__PURE__ */ r(
                    ue,
                    {
                      name: "ArrowDown",
                      width: "24px",
                      height: "24px",
                      className: T(z["wage-accordion__header--icon"], {
                        [z["wage-accordion__header--icon--open"]]: c
                      })
                    }
                  ),
                  /* @__PURE__ */ r(
                    O,
                    {
                      type: "label",
                      size: "small",
                      extraClass: z["wage-accordion__header--title"],
                      children: e.title
                    }
                  )
                ] }),
                /* @__PURE__ */ _(O, { type: "label", size: "small", extraClass: z["wage-accordion__header--value"], children: [
                  e.value ? e.value : "--",
                  " ",
                  e.currency
                ] })
              ]
            }
          ),
          /* @__PURE__ */ r(
            "div",
            {
              className: T(z["wage-accordion__content"], {
                [z["wage-accordion__content--open"]]: c
              }),
              role: "region",
              "aria-labelledby": "wage-accordion__content",
              id: "wage-accordion__content",
              children: t.map((g, p) => /* @__PURE__ */ _("div", { className: z["wage-accordion__item"], lang: n, children: [
                /* @__PURE__ */ r(
                  O,
                  {
                    type: "paragraph",
                    size: "small",
                    extraClass: z["wage-accordion__item--title"],
                    children: g.title
                  }
                ),
                /* @__PURE__ */ _(
                  O,
                  {
                    type: "paragraph",
                    size: "small",
                    extraClass: z["wage-accordion__item--value"],
                    children: [
                      g.value ? g.value : "--",
                      " ",
                      g.currency
                    ]
                  }
                )
              ] }, p))
            }
          )
        ]
      }
    );
  }
), be = (e) => e.map((t) => ({
  label: t.label,
  value: t.value.toString()
})).sort((t, n) => t.value === "0" ? -1 : n.value === "0" ? 1 : t.value.localeCompare(n.value)), je = (e) => ({
  payPeriod: {
    payTitle: e.payPeriod.payLabel,
    payOptions: be(
      e.payPeriod.periodOptions
    ),
    hourTitle: e.payPeriod.hoursLabel,
    hourHoverText: e.payPeriod.hoursHoverText,
    hourErrorText: e.payPeriod.hoursRangeErrorMessage,
    payTooltipTitle: e.payPeriod.tooltip.title,
    payTooltipText: e.payPeriod.tooltip.text
  },
  wage: {
    wageTitle: e.wage.label,
    wageHoverTextHourly: e.wage.hourlyWageHoverText,
    wageHoverTextMonthly: e.wage.monthlyWageHoverText,
    wageTooltipTitle: e.wage.tooltip.title,
    wageTooltipText: e.wage.tooltip.text,
    wageRangeErrorMessage: e.wage.wageRangeErrorMessage
  },
  age: {
    ageTitle: e.age.label,
    ageTooltipTitle: e.age.tooltip.title,
    ageTooltipText: e.age.tooltip.text,
    ageOptions: be(e.age.ageGroupOptions)
  }
}), Ue = (e, t, n) => ({
  PayPeriod: e === "1" ? "Hour" : "Month",
  Employees: t.map((a) => ({
    Salary: parseFloat(a.wage.replace(",", ".")),
    Agegroup: parseInt(a.age),
    HourAmount: e === "1" ? parseFloat(a.hours.replace(",", ".")) : void 0
  })),
  IncludeHolidayBonus: n
}), de = (e, t = "", n = "", a = "") => ({
  index: e,
  wage: t,
  hours: n,
  age: a
}), Ke = (e, t, n) => ({
  Employees: t.map((a, u) => ({
    PayPeriod: e[u] === "1" ? "Hour" : "Month",
    Salary: parseFloat(a.wage.replace(",", ".")),
    Agegroup: parseInt(a.age),
    HourAmount: e[u] === "1" ? parseFloat(a.hours.replace(",", ".")) : void 0
  })),
  IncludeHolidayBonus: n
}), Re = (e, t, n) => {
  var c, o;
  const a = t ? t.result : null;
  let u = ((a == null ? void 0 : a.total.employeeCosts) ?? 0) + ((a == null ? void 0 : a.total.employerCosts) ?? 0);
  n === e.yearlySumHoverText && (u = u * 12);
  const l = [
    {
      title: e.totalRow.label.text,
      value: a ? se(u.toString()) : e.defaultValue,
      currency: n
    }
  ];
  for (let i = 0; i < e.totalRow.subsections.length; i++) {
    let g = a ? (a == null ? void 0 : a.total)[((c = e.totalRow.subsections[i]) == null ? void 0 : c.key) ?? ""] ?? e.defaultValue : e.defaultValue;
    n === e.yearlySumHoverText && (g = Number(g) * 12), l.push({
      title: ((o = e.totalRow.subsections[i]) == null ? void 0 : o.text) ?? "",
      value: se(g),
      currency: n
    });
  }
  return l;
}, Be = (e, t, n = !1, a) => {
  const u = t ? t.result : null;
  return e.outputRows.map((l) => {
    var i, g, p, s;
    const c = [];
    for (let h = 0; h < l.subsections.length; h++) {
      let x = u ? (g = u[l.label.key][((i = l.subsections[h]) == null ? void 0 : i.key) ?? ""]) == null ? void 0 : g.toString() : e.defaultValue;
      a === e.yearlySumHoverText && !isNaN(Number(x)) && (x = (Number(x) * 12).toString()), !(((p = l.subsections[h]) == null ? void 0 : p.key) === "holidayPay" && !n) && c.push({
        title: ((s = l.subsections[h]) == null ? void 0 : s.text) ?? "",
        value: se(x ?? ""),
        currency: a
      });
    }
    let o = u && "total" in (u[l.label.key] ?? {}) ? (u[l.label.key].total ?? "").toString() : e.defaultValue;
    return a === e.yearlySumHoverText && !isNaN(Number(o)) && (o = (Number(o) * 12).toString()), {
      header: {
        title: l.label.text ?? "",
        value: se(o),
        currency: a
      },
      data: c,
      lang: "fi"
    };
  });
}, ve = (e) => [
  {
    value: "1",
    name: e.timePeriodSwitch.perMonthLabel
  },
  {
    value: "2",
    name: e.timePeriodSwitch.perYearLabel
  }
], xe = (e, t) => [
  {
    text: e.print.text,
    onClick: t,
    variant: "secondary"
  },
  {
    text: e.callSales.text,
    url: e.callSales.url ?? "",
    variant: "secondary"
  },
  {
    text: e.takeOutTyEL.text,
    url: e.takeOutTyEL.url ?? "",
    variant: "primary"
  }
], Xe = (e, t, n, a, u = !1, l, c) => {
  var i;
  const o = [];
  for (let g = 0; g < n; g++) {
    let p = null;
    t != null && t.result[g] && (p = {
      errorMessage: (t == null ? void 0 : t.errorMessage) ?? null,
      result: t == null ? void 0 : t.result[g]
    });
    let s = "";
    ((i = c == null ? void 0 : c.Employees[g]) == null ? void 0 : i.PayPeriod) === "Hour" ? s = "€" : l === "1" ? s = e.monthlySumHoverText : l === "2" && (s = e.yearlySumHoverText), o.push({
      title: `${a.salary} ${He(g)}`,
      subTitle: a.estimation,
      accordionData: Be(
        e,
        p,
        u,
        s
      ),
      summaryData: Re(
        e,
        p,
        s
      )
    });
  }
  return o;
}, Te = (e, t, n) => e === "1" ? "€" : t === "1" ? n.monthlySumHoverText : t === "2" ? n.yearlySumHoverText : "€", Je = async (e, t, n) => {
  try {
    const a = await fetch(window.location.origin + e, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        __RequestVerificationToken: t
      },
      body: JSON.stringify(n)
    });
    return a.ok ? await a.json() : !1;
  } catch (a) {
    return console.error(a), !1;
  }
};
function Ce(e = [], t = [], n, a, u, l) {
  const [c, o] = N("0"), [i, g] = N([
    "0",
    "0"
  ]), [p, s] = N(e), [h, x] = N(t), d = 1, F = 500, W = 1e6, A = (w, m) => {
    m === void 0 ? o(w) : g((b) => {
      const f = [...b];
      return f[m] = w, f;
    });
  }, j = _e((w) => {
    s(
      (m) => m.filter((b, f) => f !== w)
    ), x(
      (m) => m.filter((b) => b.index !== w)
    ), l && g(
      (m) => m.filter((b, f) => f !== w)
    );
  }, []), q = () => {
    p.length >= u || (s((w) => {
      var m;
      return [
        ...w,
        { wage: "", hours: "", age: ((m = n.age.ageOptions[0]) == null ? void 0 : m.value) ?? "" }
      ];
    }), x((w) => [
      ...w,
      de(p.length - 1)
    ]), l && g((w) => [
      ...w,
      "0"
    ]));
  }, Z = (w, m, b) => {
    var E, D;
    let f = ((E = h.find((k) => k.index === b)) == null ? void 0 : E.wage) ?? "", P = ((D = h.find((k) => k.index === b)) == null ? void 0 : D.hours) ?? "";
    w === "hours" ? P = ae(
      m,
      d,
      F,
      n.payPeriod.hourErrorText ?? ""
    ) : w === "wage" && (f = ae(
      m,
      d,
      W,
      n.wage.wageRangeErrorMessage ?? ""
    )), x((k) => {
      const H = [...k], M = H.find((ee) => ee.index === b);
      return M ? (M.wage = f, M.hours = P) : H.push(de(b, f, P)), H;
    });
  }, I = _e(
    (w, m, b) => {
      let f = $e(b);
      m === "hours" && (f = L(f)), m === "wage" && (f = ze(f)), s((P) => {
        const E = [...P];
        return E[w] = {
          ...E[w],
          [m]: f.replace(".", ",")
        }, E;
      }), Z(m, f, w);
    },
    [p]
  ), L = (w) => w.replace(/^(\d{0,3})(\.\d{0,2})?.*/, "$1$2"), U = _e(() => {
    const w = p.map((m, b) => {
      var D, k, H;
      let f = ((D = h.find((M) => M.index === b)) == null ? void 0 : D.wage) ?? "", P = ((k = h.find((M) => M.index === b)) == null ? void 0 : k.hours) ?? "", E = ((H = h.find((M) => M.index === b)) == null ? void 0 : H.age) ?? "";
      return m.wage === "" ? f = a : f = ae(
        m.wage,
        d,
        W,
        n.wage.wageRangeErrorMessage ?? ""
      ), m.age === "" && (E = a), c === "1" && !l ? m.hours === "" ? P = a : P = ae(
        m.hours,
        d,
        F,
        n.payPeriod.hourErrorText ?? ""
      ) : i[b] === "1" && l && (m.hours === "" ? P = a : P = ae(
        m.hours,
        d,
        F,
        n.payPeriod.hourErrorText ?? ""
      )), de(b, f, P, E);
    });
    return x(w), w.every(
      (m) => !m.wage && !m.hours && !m.age
    );
  }, [p, c, h]);
  return {
    components: p,
    errors: h,
    addBtnHandler: q,
    removeForm: j,
    formChangeHandler: I,
    getSelectedValue: A,
    selectedValue: c,
    validateForm: U,
    compareSelectedValue: i
  };
}
const Ye = "elo-desktop", C = {
  "wage-form": "elo-wage-form",
  "radio-button": "elo-radio-button",
  desktop: Ye,
  "wage-form--single": "elo-wage-form--single",
  "wage-form--remove-button": "elo-wage-form--remove-button",
  "wage-form--pay": "elo-wage-form--pay",
  "wage-form--wage": "elo-wage-form--wage",
  "wage-form--age": "elo-wage-form--age",
  "wage-form--pay--double": "elo-wage-form--pay--double",
  "wage-form--age--label": "elo-wage-form--age--label",
  "wage-form--age--radio": "elo-wage-form--age--radio",
  "desktop--compare": "elo-desktop--compare",
  "wage-form--age--radio--compare": "elo-wage-form--age--radio--compare",
  "wage-form--age--tooltip": "elo-wage-form--age--tooltip",
  "wage-form--age--tooltip--compare": "elo-wage-form--age--tooltip--compare",
  "wage-form__required": "elo-wage-form__required",
  "wage-form__select": "elo-wage-form__select",
  "wage-form__input": "elo-wage-form__input",
  "wage-form--remove": "elo-wage-form--remove"
}, Ne = S.forwardRef(
  ({
    formInput: e,
    removeBtnClick: t,
    removeBtnText: n,
    position: a,
    single: u,
    selectedValue: l,
    getSelectedValue: c,
    data: o,
    formChange: i,
    errors: g,
    isCompare: p,
    totalAmount: s,
    ...h
  }, x) => /* @__PURE__ */ _(
    "div",
    {
      ref: x,
      className: T(C["wage-form"], {
        [C["wage-form--single"]]: u || p
      }),
      ...h,
      children: [
        /* @__PURE__ */ _(
          "div",
          {
            className: T(C["wage-form--pay"], {
              [C["wage-form--pay--double"]]: l === "1"
            }),
            children: [
              !p && /* @__PURE__ */ r(
                fe,
                {
                  label: e.payPeriod.payTitle,
                  options: e.payPeriod.payOptions,
                  getSelectedValue: c,
                  startingValue: e.payPeriod.payOptions.find(
                    (d) => d.value === l
                  ),
                  required: !0,
                  formTooltipContent: l === "0" || !l ? e.payPeriod.payTooltipText : "",
                  formTooltipTitle: l === "0" || !l ? e.payPeriod.payTooltipTitle : "",
                  wrapperClass: C["wage-form__select"],
                  name: "pay-" + a,
                  disabled: a > 0,
                  labelProminence: "high"
                },
                l
              ),
              p && /* @__PURE__ */ r(
                fe,
                {
                  label: e.payPeriod.payTitle,
                  options: e.payPeriod.payOptions,
                  getSelectedValue: c,
                  startingValue: e.payPeriod.payOptions.find(
                    (d) => d.value === l
                  ),
                  required: !0,
                  formTooltipContent: l === "0" || !l ? e.payPeriod.payTooltipText : "",
                  formTooltipTitle: l === "0" || !l ? e.payPeriod.payTooltipTitle : "",
                  wrapperClass: C["wage-form__select"],
                  name: "pay-" + a,
                  labelProminence: "high",
                  position: a
                },
                l
              ),
              l === "1" && /* @__PURE__ */ r(
                ye,
                {
                  type: "text",
                  label: e.payPeriod.hourTitle,
                  variant: "calculator",
                  hoverText: e.payPeriod.hourHoverText,
                  errorText: g.hours,
                  required: !0,
                  formTooltipTitle: e.payPeriod.payTooltipTitle,
                  formTooltipContent: e.payPeriod.payTooltipText,
                  labelProminence: "high",
                  name: "hourly-" + a,
                  value: o.hours,
                  onChange: (d) => {
                    const F = d.target.value;
                    i(a, "hours", F);
                  },
                  min: "1",
                  max: "500",
                  onWheel: () => {
                    var d;
                    (d = document.activeElement) == null || d.blur();
                  },
                  wrapperClass: C["wage-form__input"]
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ r("div", { className: C["wage-form--wage"], children: /* @__PURE__ */ r(
          ye,
          {
            type: "text",
            label: e.wage.wageTitle,
            variant: "calculator",
            hoverText: l === "0" ? e.wage.wageHoverTextMonthly : e.wage.wageHoverTextHourly,
            errorText: g.wage,
            required: !0,
            formTooltipTitle: e.wage.wageTooltipTitle,
            formTooltipContent: e.wage.wageTooltipText,
            wrapperClass: C["wage-form__input"],
            labelProminence: "high",
            name: "wage-" + a,
            value: o.wage,
            onChange: (d) => {
              const F = d.target.value;
              i(a, "wage", F);
            },
            min: "1",
            max: "1000000",
            onWheel: () => {
              var d;
              (d = document.activeElement) == null || d.blur();
            }
          }
        ) }),
        /* @__PURE__ */ _("div", { className: C["wage-form--age"], children: [
          /* @__PURE__ */ _(
            O,
            {
              type: "label",
              size: "small",
              extraClass: C["wage-form--age--label"],
              children: [
                e.age.ageTitle,
                " ",
                /* @__PURE__ */ r(
                  "span",
                  {
                    "aria-label": "Required",
                    className: C["wage-form__required"],
                    children: "*"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ r(
            "div",
            {
              className: T(C["wage-form--age--radio"], {
                [C["wage-form--age--radio--compare"]]: p && s === 3
              }),
              children: e.age.ageOptions.map((d) => /* @__PURE__ */ r(
                Ae,
                {
                  label: d.label.replace(/\s+/g, ""),
                  value: d.value,
                  name: "age-" + a,
                  required: !0,
                  checked: o.age === d.value,
                  onChange: (F) => {
                    const W = F.target.value;
                    i(a, "age", W);
                  }
                },
                d.value
              ))
            }
          ),
          /* @__PURE__ */ r(
            ge,
            {
              title: e.age.ageTooltipTitle,
              className: T(C["wage-form--age--tooltip"], {
                [C["wage-form--age--tooltip--compare"]]: p && s === 3
              }),
              children: e.age.ageTooltipText
            }
          )
        ] }),
        /* @__PURE__ */ _(
          "div",
          {
            className: T({
              [C["wage-form--remove"]]: p && s === 3
            }),
            children: [
              !u && a !== 0 && !p && /* @__PURE__ */ r(
                ie,
                {
                  onClick: () => {
                    t(a);
                  },
                  variant: "secondary",
                  iconLeft: "Minus",
                  className: C["wage-form--remove-button"],
                  children: n
                }
              ),
              p && a === 2 && /* @__PURE__ */ r(
                ie,
                {
                  onClick: () => {
                    t(a);
                  },
                  variant: "secondary",
                  iconLeft: "Minus",
                  className: C["wage-form--remove-button"],
                  children: n
                }
              )
            ]
          }
        )
      ]
    }
  )
), Qe = "elo-desktop", B = {
  "wage-form-container": "elo-wage-form-container",
  "wage-form-container--compare": "elo-wage-form-container--compare",
  desktop: Qe,
  "wage-form-container__compare": "elo-wage-form-container__compare",
  "wage-form-container__compare--triple": "elo-wage-form-container__compare--triple",
  "wage-form-container__compare--item": "elo-wage-form-container__compare--item",
  "wage-form-container__title": "elo-wage-form-container__title",
  "wage-form-container__title--icon": "elo-wage-form-container__title--icon",
  "wage-form-container__title--text": "elo-wage-form-container__title--text",
  "wage-form-container__footer": "elo-wage-form-container__footer",
  "wage-form-container__footer--add-button": "elo-wage-form-container__footer--add-button",
  "wage-form-container__footer--compare": "elo-wage-form-container__footer--compare",
  "wage-form-container__footer--checkbox": "elo-wage-form-container__footer--checkbox",
  "wage-form-container__footer--checkbox--compare": "elo-wage-form-container__footer--checkbox--compare",
  "wage-form-container__footer--submit-button": "elo-wage-form-container__footer--submit-button",
  "wage-form-container__footer--submit-button--compare": "elo-wage-form-container__footer--submit-button--compare",
  "wage-form-container__footer--error": "elo-wage-form-container__footer--error"
}, Ze = S.forwardRef(
  ({
    title: e,
    addBtnText: t,
    checkboxLabel: n,
    submitBtnText: a,
    checkboxTooltip: u,
    checkboxTooltipTitle: l,
    formInputs: c,
    removeBtnText: o,
    requiredErrorText: i,
    formErrorText: g,
    postData: p,
    activeTab: s,
    getCompareLength: h,
    compareText: x,
    getCurrentSelectedValue: d,
    ...F
  }, W) => {
    var ne, v, R;
    const [A, j] = N(!1), [q, Z] = N(!1), [I, L] = N(!1), U = ($) => /* @__PURE__ */ r(
      We,
      {
        title: s === "single" ? e : x.salary + " " + He($ ?? 0),
        icon: "Badge",
        rounded: "half",
        subtitle: s === "compare" ? x.information : void 0,
        className: B["wage-form-container__title"]
      }
    ), {
      components: w,
      errors: m,
      addBtnHandler: b,
      removeForm: f,
      formChangeHandler: P,
      getSelectedValue: E,
      selectedValue: D,
      validateForm: k
    } = Ce(
      [{ wage: "", hours: "", age: ((ne = c.age.ageOptions[0]) == null ? void 0 : ne.value) ?? "" }],
      [{ index: 0, wage: "", hours: "", age: "" }],
      c,
      i,
      10,
      !1
    );
    ce(() => {
      d(D);
    }, [D]);
    const {
      components: H,
      errors: M,
      addBtnHandler: ee,
      removeForm: oe,
      formChangeHandler: te,
      getSelectedValue: re,
      validateForm: pe,
      compareSelectedValue: K
    } = Ce(
      [
        { wage: "", hours: "", age: ((v = c.age.ageOptions[0]) == null ? void 0 : v.value) ?? "" },
        { wage: "", hours: "", age: ((R = c.age.ageOptions[0]) == null ? void 0 : R.value) ?? "" }
      ],
      [
        { index: 0, wage: "", hours: "", age: "" },
        { index: 1, wage: "", hours: "", age: "" }
      ],
      c,
      i,
      3,
      !0
    );
    ce(() => {
      s === "compare" && (H.length >= 3 ? L(!0) : L(!1)), s === "single" && (w.length >= 10 ? L(!0) : L(!1));
    }, [s, w, H]), ce(() => {
      s === "compare" && (h == null || h(K.length));
    }, [K, s]);
    const le = async ($) => {
      const y = await p($, s);
      j(y === !1);
    }, me = async ($) => {
      var y;
      if ($.preventDefault(), s === "single") {
        if (!k()) return;
        const we = Ue(D, w, q);
        await le(we);
      } else {
        if (!pe()) return;
        (y = document.getElementById("wage-output-container-compare")) == null || y.scrollIntoView();
        const we = Ke(
          K,
          H,
          q
        );
        await le(we);
      }
    };
    return /* @__PURE__ */ _(
      "div",
      {
        ref: W,
        role: "form",
        ...F,
        id: "wage-submit",
        className: T(B["wage-form-container"], {
          [B["wage-form-container--compare"]]: s === "compare"
        }),
        children: [
          s === "single" && /* @__PURE__ */ _(Fe, { children: [
            U(),
            w.map(($, y) => /* @__PURE__ */ r(
              Ne,
              {
                formInput: c,
                position: y,
                removeBtnClick: f,
                removeBtnText: o,
                single: y === 0,
                selectedValue: D,
                getSelectedValue: E,
                data: $,
                formChange: P,
                errors: m[y] ?? { index: y, wage: "", hours: "", age: "" },
                isCompare: !1
              },
              y
            ))
          ] }),
          s === "compare" && /* @__PURE__ */ r(
            "div",
            {
              className: T(B["wage-form-container__compare"], {
                [B["wage-form-container__compare--triple"]]: H.length === 3
              }),
              children: H.map(($, y) => /* @__PURE__ */ _(
                "div",
                {
                  className: B["wage-form-container__compare--item"],
                  children: [
                    U(y),
                    /* @__PURE__ */ r(
                      Ne,
                      {
                        formInput: c,
                        position: y,
                        removeBtnClick: oe,
                        removeBtnText: x.removeSalary,
                        single: y === 0,
                        selectedValue: K[y] ?? "0",
                        getSelectedValue: re,
                        data: $,
                        formChange: te,
                        errors: M[y] ?? {
                          index: y,
                          wage: "",
                          hours: "",
                          age: ""
                        },
                        isCompare: !0,
                        totalAmount: H.length
                      }
                    )
                  ]
                },
                y
              ))
            }
          ),
          /* @__PURE__ */ _(
            "div",
            {
              className: T(B["wage-form-container__footer"], {
                [B["wage-form-container__footer--compare"]]: s === "compare"
              }),
              children: [
                /* @__PURE__ */ r(
                  ie,
                  {
                    onClick: s === "single" ? b : ee,
                    variant: "ghost",
                    iconLeft: "Plus",
                    className: B["wage-form-container__footer--add-button"],
                    disabled: I,
                    children: s === "single" ? t : x.addSalary
                  }
                ),
                /* @__PURE__ */ _(
                  "div",
                  {
                    className: T(B["wage-form-container__footer--checkbox"], {
                      [B["wage-form-container__footer--checkbox--compare"]]: s === "compare"
                    }),
                    children: [
                      /* @__PURE__ */ r(
                        Se,
                        {
                          label: n,
                          checked: q,
                          onClick: () => {
                            Z(($) => !$);
                          },
                          onChange: () => {
                          }
                        }
                      ),
                      /* @__PURE__ */ r(ge, { title: l, children: u })
                    ]
                  }
                ),
                /* @__PURE__ */ r(
                  ie,
                  {
                    type: "submit",
                    variant: "primary",
                    className: T(
                      B["wage-form-container__footer--submit-button"],
                      {
                        [B["wage-form-container__footer--submit-button--compare"]]: s === "compare"
                      }
                    ),
                    onClick: me,
                    children: s === "single" ? a : x.calculate
                  }
                ),
                A && g && /* @__PURE__ */ r(
                  O,
                  {
                    size: "small",
                    type: "paragraph",
                    extraClass: B["wage-form-container__footer--error"],
                    children: g
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
), Ie = "elo-desktop", X = {
  "wage-output-container": "elo-wage-output-container",
  "wage-output-container__header": "elo-wage-output-container__header",
  desktop: Ie,
  "wage-output-container__title": "elo-wage-output-container__title",
  "wage-output-container__content": "elo-wage-output-container__content",
  "wage-output-container__button-wrapper": "elo-wage-output-container__button-wrapper",
  "wage-output-container__button-switch": "elo-wage-output-container__button-switch"
}, ea = S.forwardRef(
  ({
    title: e,
    buttons: t,
    onChangeFunction: n,
    summaryData: a,
    buttonData: u,
    accordionData: l,
    tooltipTitle: c,
    tooltipContent: o,
    displayButtonSwitch: i,
    ...g
  }, p) => /* @__PURE__ */ _("div", { ref: p, ...g, className: X["wage-output-container"], children: [
    /* @__PURE__ */ _("div", { className: X["wage-output-container__header"], children: [
      /* @__PURE__ */ r(
        O,
        {
          type: "heading",
          size: "large",
          extraClass: X["wage-output-container__title"],
          children: e
        }
      ),
      i && /* @__PURE__ */ _("div", { className: X["wage-output-container__button-wrapper"], children: [
        /* @__PURE__ */ r(
          Oe,
          {
            buttons: t,
            onChangeFunction: n,
            className: X["wage-output-container__button-switch"]
          }
        ),
        /* @__PURE__ */ r(ge, { title: c, children: o })
      ] })
    ] }),
    /* @__PURE__ */ r("div", { className: X["wage-output-container__content"], children: l.map((s, h) => /* @__PURE__ */ r(
      Ee,
      {
        header: s.header,
        data: s.data,
        lang: s.lang,
        defaultOpen: h === 0
      },
      h
    )) }),
    /* @__PURE__ */ r(Pe, { summaryData: a, buttonData: u })
  ] })
), aa = "elo-desktop", J = {
  "wage-output-compare": "elo-wage-output-compare",
  "wage-output-compare__header": "elo-wage-output-compare__header",
  desktop: aa,
  "wage-output-compare__title": "elo-wage-output-compare__title",
  "wage-output-compare__subtitle": "elo-wage-output-compare__subtitle",
  "wage-output-compare__content": "elo-wage-output-compare__content",
  "wage-output-compare__content--triple": "elo-wage-output-compare__content--triple"
}, oa = S.forwardRef(
  ({ title: e, subTitle: t, summaryData: n, accordionData: a, isTriple: u, ...l }, c) => /* @__PURE__ */ _("div", { ref: c, ...l, className: J["wage-output-compare"], children: [
    /* @__PURE__ */ _("div", { className: J["wage-output-compare__header"], children: [
      /* @__PURE__ */ _(
        O,
        {
          type: "label",
          size: "large",
          extraClass: J["wage-output-compare__title"],
          children: [
            /* @__PURE__ */ r(ue, { name: "Badge", width: "24px", height: "24px" }),
            e
          ]
        }
      ),
      /* @__PURE__ */ r(
        O,
        {
          type: "label",
          size: "large",
          extraClass: J["wage-output-compare__subtitle"],
          children: t
        }
      )
    ] }),
    /* @__PURE__ */ r(
      "div",
      {
        className: T(J["wage-output-compare__content"], {
          [J["wage-output-compare__content--triple"]]: u
        }),
        children: a.map((o, i) => /* @__PURE__ */ r(
          Ee,
          {
            header: o.header,
            data: o.data,
            lang: o.lang,
            defaultOpen: i === 0
          },
          i
        ))
      }
    ),
    /* @__PURE__ */ r(
      Pe,
      {
        summaryData: n,
        buttonData: [],
        isCompare: !0,
        isTriple: u
      }
    )
  ] })
), ta = "elo-desktop", V = {
  "wage-output-container-compare": "elo-wage-output-container-compare",
  "wage-output-container-compare__header": "elo-wage-output-container-compare__header",
  desktop: ta,
  "wage-output-container-compare__title": "elo-wage-output-container-compare__title",
  "wage-output-container-compare__button-wrapper": "elo-wage-output-container-compare__button-wrapper",
  "wage-output-container-compare__button-switch": "elo-wage-output-container-compare__button-switch",
  "wage-output-container-compare__content": "elo-wage-output-container-compare__content",
  "wage-output-container-compare__content--triple": "elo-wage-output-container-compare__content--triple",
  "wage-output-container-compare__submit-wrapper": "elo-wage-output-container-compare__submit-wrapper",
  "wage-output-container-compare__button": "elo-wage-output-container-compare__button",
  "wage-output-compare": "elo-wage-output-compare",
  "wage-output-compare__header": "elo-wage-output-compare__header"
}, ra = S.forwardRef(
  ({
    title: e,
    buttons: t,
    onChangeFunction: n,
    outputData: a,
    buttonData: u,
    tooltipTitle: l,
    tooltipContent: c,
    displayButtonSwitch: o,
    ...i
  }, g) => /* @__PURE__ */ _(
    "div",
    {
      ref: g,
      ...i,
      className: V["wage-output-container-compare"],
      id: "wage-output-container-compare",
      children: [
        /* @__PURE__ */ _("div", { className: V["wage-output-container-compare__header"], children: [
          /* @__PURE__ */ r(
            O,
            {
              type: "heading",
              size: "large",
              extraClass: V["wage-output-container-compare__title"],
              children: e
            }
          ),
          o && /* @__PURE__ */ _(
            "div",
            {
              className: V["wage-output-container-compare__button-wrapper"],
              children: [
                /* @__PURE__ */ r(
                  Oe,
                  {
                    buttons: t,
                    onChangeFunction: n,
                    className: V["wage-output-container-compare__button-switch"]
                  }
                ),
                /* @__PURE__ */ r(ge, { title: l, children: c })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ r(
          "div",
          {
            className: T(V["wage-output-container-compare__content"], {
              [V["wage-output-container-compare__content--triple"]]: a.length === 3
            }),
            children: a.map((p, s) => /* @__PURE__ */ r(
              oa,
              {
                title: p.title,
                subTitle: p.subTitle,
                accordionData: p.accordionData,
                summaryData: p.summaryData,
                isTriple: a.length === 3
              },
              s
            ))
          }
        ),
        /* @__PURE__ */ r(
          "div",
          {
            className: V["wage-output-container-compare__submit-wrapper"],
            children: u.map(
              (p, s) => ke(
                p,
                s,
                V["wage-output-container-compare__button"]
              )
            )
          }
        )
      ]
    }
  )
), Q = {
  salary: {
    grossSalary: 2e3,
    holidayPay: 100,
    total: 2100
  },
  pensionContribution: {
    employerShare: 1e6,
    employeeShare: 50,
    total: 150
  },
  otherSideCosts: {
    healthInsurance: 50,
    unemploymentInsuranceEmployee: 20,
    unemploymentInsuranceEmployer: 30,
    accidentInsurance: 40,
    total: 100
  },
  total: {
    employerCosts: 25e3,
    employeeCosts: 400
  }
}, la = {
  errorMessage: null,
  result: Q
}, na = {
  errorMessage: null,
  result: [Q, Q]
}, ca = {
  errorMessage: null,
  result: [Q, Q, Q]
}, Y = {
  "wage-calculator": "elo-wage-calculator",
  "wage-calculator__content": "elo-wage-calculator__content",
  "wage-form-container": "elo-wage-form-container",
  "wage-form-container--compare": "elo-wage-form-container--compare",
  "wage-calculator__content--compare": "elo-wage-calculator__content--compare",
  "wage-calculator__tabs": "elo-wage-calculator__tabs",
  "wage-calculator__title": "elo-wage-calculator__title",
  "wage-calculator__title--compare": "elo-wage-calculator__title--compare"
}, _a = ({
  buttons: e,
  title: t,
  calculationTabLabel: n,
  comparisonTabLabel: a,
  mandatoryFieldMessage: u,
  calculationErrorMessage: l,
  employeeInformation: c,
  estimationSection: o,
  additionalEmployeeSection: i,
  requestVerificationToken: g,
  apiUrl: p,
  apiCompareUrl: s,
  comparisonTexts: h
}) => {
  const [x, d] = N(null), [F, W] = N(null), [A, j] = N("single"), [q, Z] = N(2), [I, L] = N(!1), [U, w] = N(!1), [m, b] = N("1"), [f, P] = N("1"), [E, D] = N("0"), [k, H] = N(null), [M, ee] = N(!0), oe = De(null), te = Le.useReactToPrint({
    documentTitle: "Wage Calculator",
    contentRef: oe
  }), re = (v) => {
    A === "single" ? b(v) : P(v);
  }, pe = (v) => {
    Z(v);
  }, K = (v) => {
    D(v);
  }, le = (v, R) => v === "single" ? (L(R.IncludeHolidayBonus), d(la), !0) : (H(R), w(R.IncludeHolidayBonus), W(q === 2 ? na : ca), !0), me = async (v, R) => {
    const y = await Je(v === "single" ? p : s, g, R);
    return y && (y.errorMessage === null || y.errorMessage === void 0) ? (v === "single" ? (L(R.IncludeHolidayBonus), d(y)) : (H(R), w(R.IncludeHolidayBonus), W(y)), !0) : !1;
  }, ne = async (v, R) => window.location.origin.includes("localhost:6006") ? le(R, v) : me(R, v);
  return ce(() => {
    k && k.Employees.length > 0 && ee(
      !k.Employees.every((v) => v.PayPeriod === "Hour")
    );
  }, [k]), /* @__PURE__ */ _(
    Me,
    {
      ref: oe,
      className: Y["wage-calculator"],
      id: "wage-calculator",
      children: [
        /* @__PURE__ */ _(
          O,
          {
            type: "heading",
            size: "medium",
            extraClass: T(Y["wage-calculator__title"], {
              [Y["wage-calculator__title--compare"]]: A === "compare"
            }),
            children: [
              /* @__PURE__ */ r(ue, { name: "Calculate", width: "40px", height: "40px" }),
              t
            ]
          }
        ),
        /* @__PURE__ */ r(
          Ve,
          {
            tabs: [
              { name: n, value: "single" },
              { name: a, value: "compare" }
            ],
            onChangeFunction: (v) => j(v),
            className: T({
              [Y["wage-calculator__tabs"]]: A === "compare"
            })
          }
        ),
        /* @__PURE__ */ _(
          "div",
          {
            className: T(Y["wage-calculator__content"], {
              [Y["wage-calculator__content--compare"]]: A === "compare"
            }),
            children: [
              /* @__PURE__ */ r(
                Ze,
                {
                  title: c.employeeInformationTitle,
                  addBtnText: e.addEmployee.text,
                  checkboxLabel: i.includeHolidayBonusLabel,
                  submitBtnText: e.calculate.text,
                  checkboxTooltip: i.tooltip.text,
                  checkboxTooltipTitle: i.tooltip.title,
                  formInputs: je(c),
                  removeBtnText: e.removeEmployee.text,
                  requiredErrorText: u,
                  formErrorText: l,
                  postData: ne,
                  activeTab: A,
                  getCompareLength: pe,
                  compareText: h,
                  getCurrentSelectedValue: K
                }
              ),
              A === "single" && /* @__PURE__ */ r(
                ea,
                {
                  title: o.title,
                  buttons: ve(o),
                  tooltipTitle: o.tooltip.title,
                  tooltipContent: o.tooltip.text,
                  onChangeFunction: re,
                  accordionData: Be(
                    o,
                    x,
                    I,
                    Te(E, m, o)
                  ),
                  summaryData: Re(
                    o,
                    x,
                    Te(E, m, o)
                  ),
                  buttonData: xe(e, te),
                  displayButtonSwitch: E === "0"
                }
              ),
              A === "compare" && /* @__PURE__ */ r(
                ra,
                {
                  title: o.title,
                  buttons: ve(o),
                  onChangeFunction: re,
                  outputData: Xe(
                    o,
                    F,
                    q,
                    h,
                    U,
                    f,
                    k
                  ),
                  buttonData: xe(e, te),
                  tooltipTitle: o.tooltip.title,
                  tooltipContent: o.tooltip.text,
                  displayButtonSwitch: M
                }
              )
            ]
          }
        )
      ]
    }
  );
}, he = {
  "button-switch": "elo-button-switch",
  "button-switch__button": "elo-button-switch__button",
  "button-switch__button--active": "elo-button-switch__button--active"
}, Oe = S.forwardRef(
  ({ buttons: e, onChangeFunction: t, ...n }, a) => {
    var o;
    const [u, l] = S.useState((o = e[0]) == null ? void 0 : o.value), c = (i) => {
      l(i), t(i);
    };
    return e = e.slice(0, 2), /* @__PURE__ */ r("div", { ref: a, ...n, className: T(he["button-switch"], n.className), children: e.map((i) => /* @__PURE__ */ r(
      "button",
      {
        onClick: () => c(i.value),
        className: T(he["button-switch__button"], {
          [he["button-switch__button--active"]]: u === i.value
        }),
        disabled: i.disabled,
        "aria-pressed": u === i.value,
        "aria-expanded": u === i.value,
        children: /* @__PURE__ */ r(O, { type: "paragraph", size: "small", children: i.name })
      },
      i.value
    )) });
  }
);
export {
  Oe as B,
  Pe as W,
  Ee as a,
  Ze as b,
  Ne as c,
  ea as d,
  ra as e,
  oa as f,
  _a as g,
  Ue as h,
  de as i,
  Ke as j,
  Re as k,
  Be as l,
  je as m,
  ve as n,
  xe as o,
  Xe as p,
  Te as q,
  Je as s,
  be as v
};
